import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/.pnpm/lucide-react@1.39.0_react@19.2.8/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/.pnpm/next@16.3.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.4.1_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/.pnpm/next@16.3.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.4.1_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomeBentoGrid"] */ "/vercel/path0/web/src/components/bento-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteNav"] */ "/vercel/path0/web/src/components/site-nav.tsx");
